module.exports = __webpack_public_path__ + "img/_DSC4727.491a36a4.webp";